import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SettingsIcon from "@mui/icons-material/Settings";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

export const SidebarData = [
  {
    title: "Menu",
    outlinedIcon: <MenuIcon />,
    filledIcon: <MenuIcon />,
    link: "#", // Toggle collapse
  },
  {
    title: "Home",
    outlinedIcon: <HomeOutlinedIcon />,
    filledIcon: <HomeIcon />,
    link: "/Home",
  },
  {
    title: "Documents",
    outlinedIcon: <InsertDriveFileOutlinedIcon />,
    filledIcon: <InsertDriveFileIcon />,
    link: "/Documents",
  },
  {
    title: "Calendar",
    outlinedIcon: <CalendarMonthOutlinedIcon />,
    filledIcon: <CalendarMonthIcon />,
    link: "/calendar",
  },
  {
    title: "Settings",
    outlinedIcon: <SettingsOutlinedIcon />,
    filledIcon: <SettingsIcon />,
    link: "/Settings",
  },
];